
















































































































































import { mapState } from 'vuex'
import DashboardItems from '@/navigation/dashboard'
import { portalState } from '@/state'

interface DashboardItem {
    icons: {
      menu: string;
      dashboard: string;
    };
    title: string;
    componentName: string;
    permission: string;
    button: {
      text: string;
      url: {
        name: string;
      };
    };
 }

export default {
  name: 'Main',
  props: { isMobile: Boolean },
  data () {
    return {
      drawer: null,
      showEditAccountButton: false,
      supportOptionsOpened: false
    }
  },
  computed: {
    ...mapState('Controls', ['minimized']),
    dealershopUrl () {
      return `https://dealershop.tracefy.com?portal-bearer=${portalState.bearer}`
    },
    user () {
      return portalState.user
    },
    items: () => DashboardItems.filter(d => d.componentName !== 'shop') as DashboardItem[],
    listActionStyle (): string {
      const px = this.minimized ? '0' : '10'
      return `margin-right: ${px}px; transition: 0.3s ease all;`
    },
    iconStyle (): string {
      return this.minimized
        ? 'margin: 0 auto'
        : ''
    },
    permittedItems (): DashboardItem[] {
      return this.items
        .filter((item: DashboardItem) => this.hasPermission(item.permission))
    },
    dealershop (): DashboardItem | false {
      const dealershopRoute = DashboardItems.find(d => d.componentName === 'shop')
      const dealershopPermission = this.hasPermission(dealershopRoute?.permission)
      if (!dealershopPermission || !dealershopRoute) return false
      return dealershopRoute
    }
  },
  methods: {
    openSupport () {
      this.supportOptionsOpened = !this.supportOptionsOpened
    }
  },
  created () {
    if (this.isMobile) {
      this.drawer = false
    }
  }
}
